import React from 'react';
import SimpleDialog from "../../dialogs/SimpleDialog";
import {capitalizeFirstLetter} from "../../../../utils/GenericUtils";

export const CompilaMonitoraggioDialog = ({monitoraggio, setOpen}) => {
	console.log(monitoraggio);
	
	return (
        <React.Fragment>
            <SimpleDialog
				open={monitoraggio !== ""}
				handleClose={() => setOpen("")}
				title={"Monitoraggio del paziente"}
				content={
					<React.Fragment>
						{monitoraggio && Object.entries(monitoraggio).map(([key, val]) => {
							return (
                                <div key={key}>
                                    <b>{capitalizeFirstLetter(key.replace(/([a-z0-9])([A-Z])/g, '$1 $2'))} : </b>
                                    <i>
                                        {val === null ? "--" : val === true ? "presente" : "assente"}
                                    </i>
                                </div>
                            );
						})}
					</React.Fragment>
				}
			/>
        </React.Fragment>
    );
};
